import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type { PslfFormExtension } from 'tio-data/data/resources/pslf-form.ext';

export interface PslfApproverDisplayEmailSignature {
  Args: {
    Positional: [PslfFormExtension];
  };
  Return: string;
}

/**
 * Approver email for a PSLF form, swapping in a localized
 * "N/A - Sent by mail" / "N/A - Employer closed" label for print-and-mail and
 * prior-employer-closed forms.
 *
 * The label lives here rather than on the resource extension because a
 * WarpDrive resource has no owner — an `@service intl` getter on the extension
 * throws `getOwner(this).lookup` on first paint of a deep-linked load (#9002).
 * A helper resolves `intl` against its own owner.
 *
 * {{pslf-approver-display-email @form}}
 */
export default class PslfApproverDisplayEmail extends Helper<PslfApproverDisplayEmailSignature> {
  @service declare intl: IntlService;

  compute([form]: [PslfFormExtension]) {
    if (form.isPrintAndMail) {
      return `${this.intl.t('pslf.table.not_applicable')} - ${this.intl.t('pslf.table.print_and_mail')}`;
    }
    if (form.isPriorEmployerClosed) {
      return `${this.intl.t('pslf.table.not_applicable')} - ${this.intl.t('pslf.table.prior_employer_closed')}`;
    }
    return form.approverDisplayEmail;
  }
}
